<section
  *ngIf="{ thumbnails: thumbnails$ | async } as STATE"
  class="video-thumbnail-selector"
>
  <ng-container *ngIf="STATE.thumbnails as thumbnails">
    <div class="video-thumbnail-selector__list">
      <article
        *ngIf="loadedImageSrc"
        class="video-thumbnail-selector__list__item video-thumbnail-selector__list__item--selected"
      >
        <img [lazyLoad]="loadedImageSrc" alt="add_file" />
        <div>
          <button>
            <i class="fa-solid fa-check"></i>
          </button>
        </div>
      </article>
      <article
        (click)="selectMedia(item.id)"
        *ngFor="let item of thumbnails"
        class="video-thumbnail-selector__list__item"
        [class.video-thumbnail-selector__list__item--selected]="
          selectedMediaId
            ? item.id === selectedMediaId
            : item.tags.includes('default_thumb')
        "
      >
        <img [lazyLoad]="item.publicUrl" alt="add_file" />
        <div>
          <button>
            <i class="fa-solid fa-check"></i>
          </button>
        </div>
      </article>
    </div>

    <button
      (click)="fileInput.click()"
      class="video-thumbnail-selector__button"
    >
      <img [src]="'assets/icons/plus-circle-blue.svg'" alt="add_file" />
    </button>
    <input
      #fileInput
      [accept]="supportedFileExtensions"
      type="file"
      (change)="onChange($event)"
    />
  </ng-container>

  <loading-or-error *ngIf="!STATE.thumbnails"></loading-or-error>
</section>
